import styled from '@emotion/styled';

const TimestampsIndicator = styled.div`
    line-height: 1.6rem;
    font-size: 1.2rem;
    font-weight: 500;
    background-color: ${({ theme }) => theme.colors.black[50]};
    padding: 0.4rem;
    border-radius: 0.4rem;
    color: ${({ theme }) => theme.colors.black[700]};
    display: flex;
    align-items: center;
`;

const Hyphen = styled.div`
    width: 12px;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.black[700]};
`;

interface IProps {
    start: number;
    end: number;
}

function formatTimestamp(seconds: number) {
    const totalMilliseconds = Math.floor(seconds * 1000);

    const hours = Math.floor(totalMilliseconds / (60 * 60 * 1000));
    const minutes = Math.floor((totalMilliseconds % (60 * 60 * 1000)) / (60 * 1000));
    const secs = Math.floor((totalMilliseconds % (60 * 1000)) / 1000);
    const milliseconds = totalMilliseconds % 1000;

    const pad = (val: number, length: number) => String(val).padStart(length, '0');

    return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(secs, 2)},${pad(milliseconds, 3)}`;
}

function PhraseTimestampsIndicator({ start, end }: IProps) {
    return (
        <TimestampsIndicator>
            {formatTimestamp(start)}
            &nbsp;
            <Hyphen />
            &nbsp;
            {formatTimestamp(end)}
        </TimestampsIndicator>
    );
}

export default PhraseTimestampsIndicator;
